import { render, staticRenderFns } from "./AddToGroupModal.vue?vue&type=template&id=b005539c&scoped=true"
import script from "./AddToGroupModal.vue?vue&type=script&lang=js"
export * from "./AddToGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddToGroupModal.vue?vue&type=style&index=0&id=b005539c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b005539c",
  null
  
)

export default component.exports